module.exports = " <the-head></the-head> <coder></coder> <introduction></introduction> <code-tables></code-tables> <the-foot></the-foot> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 157
 ** module chunks = 2
 **/